// extracted by mini-css-extract-plugin
export default {"container":"explore-activities_container__jgiB4"};